import React from "react";

export const UpdateBanner = ({ onReload }) => {
  return (
    <div
      className="alert alert-info alert-dismissible fade show m-0 rounded-0 border-0 d-flex align-items-center justify-content-between"
      role="alert"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        borderTop: "2px solid #0dcaf0",
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <i className="bi bi-arrow-clockwise fs-5"></i>
        <div>
          <strong>Nova versão disponível!</strong>
          <span className="ms-2">
            Uma atualização está disponível. Clique para recarregar e ver as
            novidades.
          </span>
        </div>
      </div>
      <button
        type="button"
        className="btn btn-sm btn-warning text-white fw-bold"
        onClick={onReload}
        style={{
          whiteSpace: "nowrap",
          backgroundColor: "#ff8c00",
          borderColor: "#ff8c00"
        }}
      >
        <i className="bi bi-arrow-clockwise me-1"></i>
        Atualizar Agora
      </button>
    </div>
  );
};